import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ScannerAuth = ({ onAuthenticate, isLoading }) => {
  const [scannerCode, setScannerCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    setError('');

    // Mock authentication - in real app this would validate against backend
    const validCodes = ['123456', '789012', '345678'];
    
    if (!scannerCode?.trim()) {
      setError('Please enter scanner code');
      return;
    }

    if (scannerCode?.length !== 6) {
      setError('Scanner code must be 6 digits');
      return;
    }

    if (!validCodes?.includes(scannerCode)) {
      setError('Invalid scanner code. Please check and try again.');
      return;
    }

    // Simulate authentication delay
    setTimeout(() => {
      onAuthenticate({
        code: scannerCode,
        eventName: 'Summer Music Festival 2024',
        venue: 'Central Park Amphitheater',
        scannerName: 'Main Entrance Scanner',
        permissions: ['entry', 'upgrade', 'merchandise', 'member']
      });
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card rounded-lg shadow-elevation-3 p-6">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="QrCode" size={32} color="white" />
          </div>
          <h1 className="text-2xl font-semibold text-foreground mb-2">Event Scanner</h1>
          <p className="text-muted-foreground">
            Enter your 6-digit scanner code to access the scanning interface
          </p>
        </div>

        {/* Authentication Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Scanner Code"
            type="text"
            placeholder="Enter 6-digit code"
            value={scannerCode}
            onChange={(e) => {
              const value = e?.target?.value?.replace(/\D/g, '')?.slice(0, 6);
              setScannerCode(value);
              setError('');
            }}
            error={error}
            required
            className="text-center text-lg font-mono tracking-widest"
            maxLength={6}
          />

          <Button
            type="submit"
            variant="default"
            size="lg"
            loading={isLoading}
            disabled={scannerCode?.length !== 6}
            iconName="LogIn"
            className="w-full"
          >
            Access Scanner
          </Button>
        </form>

        {/* Help Section */}
        <div className="mt-6 p-4 bg-muted rounded-lg">
          <h3 className="text-sm font-medium text-foreground mb-2">Need Help?</h3>
          <div className="space-y-2 text-xs text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="Key" size={14} />
              <span>Scanner codes are provided by event managers</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Phone" size={14} />
              <span>Support: (555) 123-4567</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Mail" size={14} />
              <span>Email: scanner-support@tixful.com</span>
            </div>
          </div>
        </div>

        {/* Mock Credentials Info */}
        <div className="mt-4 p-3 bg-accent bg-opacity-10 rounded-lg">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={14} className="text-accent mt-0.5" />
            <div className="text-xs">
              <p className="font-medium text-foreground mb-1">Demo Codes:</p>
              <p className="text-muted-foreground">123456, 789012, 345678</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScannerAuth;